import { render, staticRenderFns } from "./ProductBox.vue?vue&type=template&id=2ffa4ee2&scoped=true&"
import script from "./ProductBox.vue?vue&type=script&lang=js&"
export * from "./ProductBox.vue?vue&type=script&lang=js&"
import style0 from "./ProductBox.vue?vue&type=style&index=0&id=2ffa4ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa4ee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/builder/shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ffa4ee2')) {
      api.createRecord('2ffa4ee2', component.options)
    } else {
      api.reload('2ffa4ee2', component.options)
    }
    module.hot.accept("./ProductBox.vue?vue&type=template&id=2ffa4ee2&scoped=true&", function () {
      api.rerender('2ffa4ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductBox/ProductBox.vue"
export default component.exports